<template lang='pug'>
  i.svg-icon.svg-icon-chart
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100')

      path(fill="#FFFFFF" d="M60.04,6c12.42,0,24.85,0,37.27,0c0,28.87,0,57.75,0,86.62c-31.87,0-63.75,0-95.62,0c0-28.87,0-57.75,0-86.62 c12.48,0,24.96,0,37.44,0c-0.47,0.33-1.08,0.57-1.36,1.02c-0.25,0.39-0.16,1.02-0.16,1.54c-0.01,27.1-0.01,54.2-0.01,81.3 c0,0.23,0,0.45,0,0.68c0.03,1.28,0.65,1.92,1.94,1.92c6.63,0.01,13.27,0.01,19.9-0.01c0.33,0,0.7-0.15,0.99-0.32 c0.89-0.52,0.94-1.41,0.94-2.31c0-27.01,0-54.03,0.01-81.04C61.39,7.59,61.13,6.61,60.04,6z M73.35,58.13c0,1.86,0,3.71,0,5.57 c0,8.86,0.01,17.72-0.01,26.58c0,0.87,0.22,1.59,1,1.95c0.43,0.2,0.98,0.21,1.47,0.21c6.27,0.01,12.53,0.01,18.8,0.01 c1.81,0,2.52-0.7,2.52-2.5c0-21.18,0.01-42.37-0.01-63.55c0-1.76-0.61-2.34-2.31-2.35c-6.41-0.03-12.81-0.02-19.22,0 c-1.39,0-2.27,0.48-2.26,2.27C73.38,36.91,73.35,47.52,73.35,58.13z M1.87,69.08c0,7.06,0,14.13,0,21.19c0,1.49,0.69,2.18,2.18,2.18 c6.44,0,12.87-0.02,19.31,0.02c1.42,0.01,2.3-0.83,2.3-2.32c-0.01-14.07,0-28.14-0.02-42.21c0-1.72-0.62-2.27-2.28-2.28 c-6.41-0.05-12.82-0.04-19.22-0.01c-1.69,0.01-2.3,0.65-2.29,2.32C1.89,55.01,1.87,62.04,1.87,69.08z")

      path(fill="#4DA750" d="M60.04,6c1.09,0.61,1.35,1.59,1.35,2.77c-0.01,27.01-0.01,54.03-0.01,81.04c0,0.9-0.05,1.79-0.94,2.31 c-0.3,0.17-0.66,0.32-0.99,0.32c-6.63,0.02-13.27,0.02-19.9,0.01c-1.29,0-1.92-0.64-1.94-1.92c0-0.23,0-0.45,0-0.68 c0-27.1,0-54.2,0.01-81.3c0-0.52-0.08-1.15,0.16-1.54c0.28-0.45,0.89-0.69,1.36-1.02C46.1,6,53.07,6,60.04,6z")

      path(fill="#368BCB" d="M72,58.13c0-10.61,0.02-21.21-0.02-31.82c-0.01-1.79,0.87-2.26,2.26-2.27c6.41-0.02,12.81-0.03,19.22,0 c1.7,0.01,2.31,0.6,2.31,2.35c0.01,21.18,0.01,42.37,0.01,63.55c0,1.81-0.71,2.5-2.52,2.5c-6.27,0-12.53,0-18.8-0.01 c-0.49,0-1.04-0.01-1.47-0.21c-0.78-0.37-1-1.08-1-1.95C72.01,81.42,72,72.56,72,63.7C72,61.84,72,59.98,72,58.13z")

      path(fill="#F5BB1F" d="M3,69.08c0-7.04,0.02-14.07-0.02-21.1c-0.01-1.66,0.6-2.31,2.29-2.32c6.41-0.03,12.82-0.04,19.22,0.01 c1.66,0.01,2.27,0.56,2.28,2.28c0.02,14.07,0.01,28.14,0.02,42.21c0,1.48-0.88,2.32-2.3,2.32c-6.44-0.04-12.87-0.02-19.31-0.02 C3.69,92.45,3,91.76,3,90.27C3,83.21,3,76.14,3,69.08z")

</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};
</script>
